import { render, staticRenderFns } from "./UniversityExamConfig.vue?vue&type=template&id=73d57bd5"
import script from "./UniversityExamConfig.vue?vue&type=script&lang=js"
export * from "./UniversityExamConfig.vue?vue&type=script&lang=js"
import style0 from "./UniversityExamConfig.vue?vue&type=style&index=0&id=73d57bd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports